import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'url-polyfill';
import { createHashHistory } from 'history';
import { routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import * as Sentry from '@sentry/react';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import { GlobalStyle } from './globalStyles';
import { releaseVersion, sentryErrorTrackingDsn } from './config';
import App from './App';
import createRootReducer from './store/ducks';
import sagas from './store/sagas';
import withClearCache from './withClearCache';

if (window.location.hostname !== 'localhost') {
  Sentry.init({ dsn: sentryErrorTrackingDsn });
  Sentry.setContext('release', {
    version: releaseVersion,
  });
}

export const history = createHashHistory();
const sagaMiddleware = createSagaMiddleware();
const store = createStore(createRootReducer(history), composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history))));
const ClearCacheComponent = withClearCache(App);
sagaMiddleware.run(sagas);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <GlobalStyle />
      <ClearCacheComponent />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
